
document.addEventListener("DOMContentLoaded", () => {

  const button = document.querySelector(".product-form__submit");

  if (!button) return;

  function getSkioPicker() {
    return document.querySelector("skio-plan-picker");
  }

  function getSkioPrice() {
    const picker = getSkioPicker();

    if (!picker || !picker.shadowRoot) return null;

    const selected = picker.shadowRoot.querySelector(
      ".group-container--selected"
    );

    if (!selected) return null;

    const priceElement = selected.querySelector(".skio-price");

    if (!priceElement) return null;

    const clone = priceElement.cloneNode(true);

    const compareAt = clone.querySelector("s");

    if (compareAt) {
      compareAt.remove();
    }

    return clone.textContent.replace(/\s+/g, " ").trim();
  }

  function getVariantPrice() {
    const product = window.ShopifyAnalytics?.meta?.product;
    const variantInput = document.querySelector('input[name="id"]');

    if (!product || !variantInput) return null;

    const variant = product.variants.find(
      v => v.id === Number(variantInput.value)
    );

    if (!variant) return null;

    return (variant.price / 100).toLocaleString("en-US", {
      style: "currency",
      currency: "USD"
    });
  }

  function updateButton() {
    const label = button.querySelector("span");

    if (!label) return;

    const price = getSkioPrice() || getVariantPrice();

    if (!price) return;

    const html =
      `ADD TO CART <span class="add-to-cart-price"> · ${price}</span>`;

    if (label.innerHTML !== html) {
      label.innerHTML = html;
    }
  }

  // Primera ejecución
  updateButton();

  // Skio puede tardar en renderizar
  setTimeout(updateButton, 300);
  setTimeout(updateButton, 700);
  setTimeout(updateButton, 1200);
  setTimeout(updateButton, 2000);

  // Observar cambios dentro del Shadow DOM de Skio
  function observeSkio() {
    const picker = getSkioPicker();

    if (!picker || !picker.shadowRoot) {
      setTimeout(observeSkio, 300);
      return;
    }

    const observer = new MutationObserver(() => {
      updateButton();
    });

    observer.observe(picker.shadowRoot, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true
    });

    updateButton();
  }

  observeSkio();

  // Cambios de variante y de selling plan
  document.addEventListener("change", event => {
    if (
      event.target.matches('input[name="id"]') ||
      event.target.matches('input[name="selling_plan_button"]')
    ) {
      setTimeout(updateButton, 50);
      setTimeout(updateButton, 300);
      setTimeout(updateButton, 700);
    }
  });
  

});
